/* Unwind picture turntable (shopify/turntable/README.md).
   Drag or arrow keys turn a pre-rendered CAD model; the toggle plays the
   drawers out and back. Pictures only: no 3D data on the page (IP rule,
   22 Jul 2026). Ported from the Roam guide turntable (UNWIND CAD
   src/guide.py): the angle carries across picture sets by view index.

   Frame URL = base + prefix + '-s<step>-v<nn>.webp?width=<720|1200>'.
   Step 0 = closed, step steps-1 = fully open. */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function reduceMotion() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  function lowData() {
    var c = navigator.connection || {};
    return !!c.saveData || /(^|-)2g$/.test(c.effectiveType || '');
  }
  function track(name, handle, extra) {
    var p = { event: name, product_handle: handle };
    if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k];
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(p); } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        var c = {}; for (var j in p) if (j !== 'event') c[j] = p[j];
        Shopify.analytics.publish(name, c);
      }
    } catch (e2) {}
  }

  function init(root) {
    if (root.__utt) return;
    root.__utt = true;
    var stage = root.querySelector('[data-utt-stage]');
    var img = root.querySelector('[data-utt-img]');
    var hint = root.querySelector('[data-utt-hint]');
    var toggle = root.querySelector('[data-utt-toggle]');
    var live = root.querySelector('[data-utt-live]');
    var base = root.getAttribute('data-utt-base');
    var prefix = root.getAttribute('data-utt-prefix');
    var handle = root.getAttribute('data-utt-handle') || '';
    var N = parseInt(root.getAttribute('data-utt-views'), 10) || 36;
    var K = parseInt(root.getAttribute('data-utt-steps'), 10) || 1;
    if (!stage || !img || !base || !prefix) return;

    var width = 1200;
    var view = 0;          // 0..N-1, view 0 = the hero angle (the poster)
    var step = 0;          // 0 = closed, K-1 = open
    var target = 0;        // the state the toggle last asked for
    var cache = {};        // 's-v' -> Image (loaded or loading)
    var queue = [];
    var inflight = 0;
    var spun = false;
    var anim = null;
    var waitKey = null;

    function pickWidth() {
      var px = stage.clientWidth * (window.devicePixelRatio || 1);
      width = px > 900 ? 1200 : 720;
    }
    function url(s, v) {
      return base + prefix + '-s' + s + '-v' + pad(v) + '.webp?width=' + width;
    }
    function key(s, v) { return s + '-' + v; }
    function ready(s, v) { var im = cache[key(s, v)]; return !!(im && im.__ok); }

    /* ---- loading: a small queue, nearest angle first ---------------- */
    function pump() {
      while (inflight < 4 && queue.length) {
        var job = queue.shift();
        var k = key(job[0], job[1]);
        if (cache[k]) continue;
        var im = new Image();
        im.decoding = 'async';
        cache[k] = im;
        inflight++;
        (function (im, s, v, k) {
          im.onload = function () {
            im.__ok = true; inflight--;
            if (waitKey === k) { waitKey = null; draw(); }
            pump();
          };
          im.onerror = function () { inflight--; delete cache[k]; pump(); };
          im.src = url(s, v);
        })(im, job[0], job[1], k);
      }
    }
    function want(s, v, front) {
      if (cache[key(s, v)]) return;
      if (front) queue.unshift([s, v]); else queue.push([s, v]);
      pump();
    }
    function preloadState(s) {
      // spiral out from the current view so the next drag is always covered
      for (var d = 0; d <= N / 2; d++) {
        want(s, (view + d) % N);
        if (d) want(s, (view - d + N) % N);
      }
    }

    /* ---- drawing ------------------------------------------------------ */
    function nearestLoaded(s, v) {
      for (var d = 0; d <= N / 2; d++) {
        if (ready(s, (v + d) % N)) return (v + d) % N;
        if (ready(s, (v - d + N) % N)) return (v - d + N) % N;
      }
      return -1;
    }
    function draw() {
      if (ready(step, view)) {
        img.removeAttribute('srcset');
        img.src = cache[key(step, view)].src;
        return;
      }
      want(step, view, true);
      waitKey = key(step, view);
      var near = nearestLoaded(step, view);
      if (near >= 0) { img.removeAttribute('srcset'); img.src = cache[key(step, near)].src; }
    }
    function turn(v) {
      view = ((v % N) + N) % N;
      draw();
    }

    /* ---- drag ---------------------------------------------------------- */
    var down = null;
    stage.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      if (e.target.closest && e.target.closest('[data-utt-toggle]')) return;
      down = { x: e.clientX, y: e.clientY, v: view, id: e.pointerId, on: false };
    });
    stage.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== down.id) return;
      var dx = e.clientX - down.x;
      if (!down.on) {
        if (Math.abs(dx) < 6) return;
        if (Math.abs(e.clientY - down.y) > Math.abs(dx)) { down = null; return; } // a scroll
        down.on = true;
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
        stage.classList.add('is-drag');
        firstSpin();
      }
      // a full stage-width drag turns the kit about three quarters round
      var per = Math.max(8, stage.clientWidth / (N * 0.75));
      if (anim) finishAnim();
      turn(down.v + Math.round(dx / per));
    });
    function up(e) {
      if (!down || (e && e.pointerId !== down.id)) return;
      down = null;
      stage.classList.remove('is-drag');
    }
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', up);
    stage.addEventListener('lostpointercapture', up);
    img.addEventListener('dragstart', function (e) { e.preventDefault(); });

    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        firstSpin();
        if (anim) finishAnim();
        turn(view + (e.key === 'ArrowRight' ? 1 : -1));
      } else if (e.key === 'Home') {
        e.preventDefault();
        turn(0);
      }
    });

    function firstSpin() {
      if (spun) return;
      spun = true;
      if (hint) hint.hidden = true;
      track('kit_spin_used', handle);
    }

    /* ---- open / close -------------------------------------------------- */
    function setToggle(open) {
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', open ? 'true' : 'false');
      toggle.textContent = toggle.getAttribute(open ? 'data-utt-close-label' : 'data-utt-open-label');
    }
    function finishAnim() {
      if (!anim) return;
      clearTimeout(anim);
      anim = null;
      step = target;
      draw();
    }
    function play(to) {
      target = to;
      setToggle(to > 0);
      if (live) live.textContent = to > 0 ? 'Opened' : 'Closed';
      if (reduceMotion() || K < 2) { step = to; draw(); preloadState(step); return; }
      var dir = to > step ? 1 : -1;
      var path = [];
      for (var s = step + dir; dir > 0 ? s <= to : s >= to; s += dir) path.push(s);
      path.forEach(function (s) { want(s, view, true); });
      var started = Date.now();
      // 250ms for the whole move (design system: drawers/panels 250ms);
      // waits up to 1.5s for frames on a slow line, then jumps.
      var per = Math.round(250 / path.length);
      (function tick() {
        if (!path.length) { anim = null; preloadState(step); return; }
        if (!ready(path[0], view) && Date.now() - started < 1500) {
          anim = setTimeout(tick, 40);
          return;
        }
        step = path.shift();
        draw();
        anim = setTimeout(tick, per);
      })();
    }
    if (toggle && K > 1) {
      toggle.hidden = false;
      toggle.addEventListener('click', function () {
        if (anim) finishAnim();
        var open = target === 0;
        play(open ? K - 1 : 0);
        if (open) track('kit_drawers_opened', handle);
      });
      // warm the toggle's first frames once the hero is in, so it is instant
      toggle.addEventListener('pointerenter', function () {
        for (var s = 1; s < K; s++) want(s, view);
      }, { once: true });
    }

    /* ---- start -------------------------------------------------------- */
    pickWidth();
    // the poster IS closed view 0: seed it so the first drag frame matches
    if (hint) hint.hidden = false;
    var started = false;
    function start() {
      if (started) return;
      started = true;
      if (lowData()) { want(0, 1); want(0, N - 1); return; }   // on demand only
      preloadState(0);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); start(); }
      }, { rootMargin: '200px' });
      io.observe(root);
    } else {
      start();
    }
    root.classList.add('is-live');
  }

  /* ---- gallery: the turntable is slide 0 of the kit-page gallery ------
     unwind-flatpack-configurator renders a [data-utt-thumb] button before
     the photo thumbs. Photo thumbs keep their own handler in
     unwind-flatpack.js; this only swaps which frame is showing. */
  function wireGallery(gal) {
    var tt = gal.querySelector('[data-utt]');
    var main = gal.querySelector('[data-fc-main]');
    if (!tt || !main) return;
    gal.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-utt-thumb]')) {
        gal.classList.add('tt-on');
        tt.hidden = false; main.hidden = true;
      } else if (t.closest('[data-fc-thumb]')) {
        gal.classList.remove('tt-on');
        tt.hidden = true; main.hidden = false;
      }
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-utt]'), init);
    Array.prototype.forEach.call(document.querySelectorAll('[data-utt-gal]'), wireGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
